// external scripts
import $ from 'jquery';
import debug from 'bows';
// import tns from './libs/tns/tiny-slider';
// example of ES2015 modules loading & tree shaking
import { emptyLinks } from './_links';

import { GoogleAddressAutocomplete } from "./modules/google-address-autocomplete";
import "./modules/send-sms";
import "./libs/textEffect.jquery";

import "./magazine-lines";
import "./mobile-menu-popup";
import "./modules/menu-feature-slider";
import "./modules/top-menu-picks-slider";
import "./modules/mobile-menu";
import "./modules/landing-delivery-areas-slider";
import "./modules/testimonials-slider";
import "./modules/stagger-text";
import "./modules/contact-form";

import fitvid from './_fitvid';

const $window   = $(window);
const $document = $(document);
const log       = debug('site');

function checkHash() {
	const { hash } = window.location;
	if(hash === "#order-now") {
		$("html, body").stop().animate({ scrollTop: $('.landing-container .hero-container h1').offset().top });
		$("#google-address-autocomplete").focus();
	}
}

class Site {
	constructor() {
		$document.ready(() => this.domReady());
		$window.on('load', () => this.windowLoad());
	}

	domReady() {
		const log = debug('site:domReady');

		// initialize fitvid videos
		fitvid();

		new GoogleAddressAutocomplete("#google-address-autocomplete", '.address-results', '.hero-container');

		log('dom.ready');

		setTimeout(function(){
			$('.welcome-box').addClass('visible')
		},3500);

		$(".nav-icon, .mobile-menu a").on("click", function (evt) {
			if($('.nav-icon').hasClass("open")) {
				$('.nav-icon').removeClass("open");
				$(".mobile-menu").slideUp();
			} else {
				$('.nav-icon').addClass("open");
				$(".mobile-menu").slideDown();
			}
		});

		$(window).on('hashchange', () => checkHash);
		checkHash();

		$('.order-now-button').on('click', () => {
			checkHash();
		});
	}

	windowLoad() {
		const log = debug('site:windowLoad');
		log('window.onload');

		// example of ES2015 modules loading & tree shaking
		emptyLinks();
	}
}

export default Site;
